// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"122": "21a578a4","299": "3269122b","354": "9c6094ad","489": "56172ab1","49": "6e2a5ed0","535": "ca3f0e03","581": "0b0bf330","783": "cad8aa23",}[chunkId] + ".js"
}